import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';

import ColorGroup from './ColorGroup';
import GroupWrapper from '../Wrappers/GroupWrapper';

const FontStyleGroup = ({ cellFormat, onFormatChange }) => {
  const handleBoldClick = useCallback(() => {
    onFormatChange('bold');
  }, [onFormatChange]);

  const handleItalicClick = useCallback(() => {
    onFormatChange('italic');
  }, [onFormatChange]);

  const handleUnderlineClick = useCallback(() => {
    onFormatChange('underline');
  }, [onFormatChange]);

  return (
    <GroupWrapper label="Font">
      <Tooltip title="Bold">
        <IconButton
          size="small"
          onClick={handleBoldClick}
          color={cellFormat?.fontWeight ? 'primary' : 'default'}
        >
          <FormatBoldIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Italic">
        <IconButton
          size="small"
          onClick={handleItalicClick}
          color={cellFormat?.fontStyle ? 'primary' : 'default'}
        >
          <FormatItalicIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Underline">
        <IconButton
          size="small"
          onClick={handleUnderlineClick}
          color={cellFormat?.textDecoration ? 'primary' : 'default'}
        >
          <FormatUnderlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <ColorGroup cellFormat={cellFormat} onFormatChange={onFormatChange} />
    </GroupWrapper>
  );
};

FontStyleGroup.propTypes = {
  cellFormat: PropTypes.shape({
    fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
    fontStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
    textDecoration: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
  }).isRequired,
  onFormatChange: PropTypes.func.isRequired,
};

export default FontStyleGroup;
